import maConfrimDamagesBtn from '@/components/button-blue'
import maButton from '@/components/buttons'
import maEventBus from '@/components/eventbus/index.js'
import maNavbarStepper from '@/components/navbarStepper'
import { mapState, mapActions, mapMutations } from 'vuex'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_GET_SINISTER_SUMMARY,
  WARRANTY_DELETE_DAMAGE,
  WARRANTY_UPDATE_MULTIDAMAGE,
  WARRANTY_UPDATE_IS_MULTIDAMAGE,
  FNOL_MODULE_NAME,
  FNOL_DAMAGES_CONFIRMED_MUT,
  FNOL_NO_DAMAGES
} from '@/store/types'
import flowMixin from '@/modules/Flow/mixins/flowMixin'

export default {
  name: 'damagesView',

  mixins: [flowMixin],

  components: {
    maButton,
    maConfrimDamagesBtn,
    maNavbarStepper
  },

  data: function() {
    return {
      damagesList: [],
      showDeleteDamageBtn: false
    }
  },
  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantyPropertyType: 'propertyType',
      stateWarrantySinisterSummary: 'sinisterSummary'
    }),

    isContinueBtnDisabled() {
      return this.damagesList.length === 0
    }
  },

  methods: {
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateIsMultidamage: WARRANTY_UPDATE_IS_MULTIDAMAGE,
      mutWarrantyUpdateMultidamage: WARRANTY_UPDATE_MULTIDAMAGE

    }),

    ...mapMutations(FNOL_MODULE_NAME, {
      mutDamagesConfirmed: FNOL_DAMAGES_CONFIRMED_MUT,
      mutNoDamages: FNOL_NO_DAMAGES
    }),

    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyGetSinisterSummary: WARRANTY_GET_SINISTER_SUMMARY,
      actWarrantyDeleteDamage: WARRANTY_DELETE_DAMAGE
    }),

    handleClickAddDamages() {
      const damageTypeViewName = 'damages-types'
      const propertyType = this.getPropertyType
      this.goToView(damageTypeViewName, { propertyType })
    },

    setDamagesData() {
      this.damagesList = this.stateWarrantySinisterSummary
    },

    /**
         * Deletes the damage and updates the damageList data
         */
    handleDeleteDamage(dataDamageId) {
      const damageId = dataDamageId
      const sinisterId = this.getSinisterId
      this.actWarrantyDeleteDamage({ damageId, sinisterId }).then(() => {
        this.actWarrantyGetSinisterSummary(sinisterId).then(() => {
          maEventBus.$emit('btnDelete:clicked')
          this.damagesList = []
          this.setDamagesData()
        })
      })
    },

    handleConfirmDamages() {
      const damageConfirmedViewName = 'damage-confirmed'
      this.goToView(damageConfirmedViewName)
    },

    hadleConfirmNoDamages() {
      const fnolViewName = 'fnol-flow'
      this.mutDamagesConfirmed(false)
      this.mutNoDamages(true)
      this.goToView(fnolViewName)
    },

    handleViewDamages(event) {
      const damageConfirmedViewName = 'damages-view'
      this.goToView(damageConfirmedViewName)
    },

    handleClickDamageDetail(dataDamageId) {
      const damageExtraDetailsViewName = 'damage-extra-details'
      const damageId = dataDamageId
      this.goToView(damageExtraDetailsViewName, { damageId })
    },

    getSubtitle(subtitle) {
      if (subtitle.toUpperCase().indexOf('MUR') !== -1) {
        return 'Murs'
      } else {
        return subtitle
      }
    }
  },

  /**
     * If stateWarrantySinisterSummary changes, it updates the damages data list
     */
  watch: {
    stateWarrantySinisterSummary() {
      this.setDamagesData()
    }
  },

  /**
     * Executes the actWarrantyGetSinisterSummary and sets the damages data list
     */
  mounted: function() {
    const sinisterId = this.getSinisterId

    this.actWarrantyGetSinisterSummary(sinisterId).then(() => {
      this.damagesList = this.stateWarrantySinisterSummary
    })
    this.mutWarrantyUpdateIsMultidamage(false)
    this.mutWarrantyUpdateMultidamage({})

    // Notify Vue App of the current active element in screen
    this.notifyAppOfChanges(this)
  }
}
